import { SloMetricType } from "../types";

export const SLO_METRIC_OPTIONS = Object.values(SloMetricType);

export const SLO_METRIC_LABELS: Record<SloMetricType, string> = {
  [SloMetricType.LATENCY]: "Latency",
  [SloMetricType.THROUGHPUT]: "Throughput",
  [SloMetricType.AVAILABILITY]: "Availability",
  [SloMetricType.ERROR_RATE]: "Error rate",
  [SloMetricType.SATURATION]: "Saturation",
  [SloMetricType.CUSTOM]: "Custom",
};

export const SLO_TARGET_PLACEHOLDERS: Partial<Record<SloMetricType, string>> = {
  [SloMetricType.LATENCY]: "e.g. p95 < 200ms",
  [SloMetricType.THROUGHPUT]: "e.g. ≥ 500 RPS",
  [SloMetricType.AVAILABILITY]: "e.g. ≥ 99.9%",
  [SloMetricType.ERROR_RATE]: "e.g. < 0.1%",
};

export function sloMetricLabel(value: SloMetricType): string {
  return SLO_METRIC_LABELS[value] ?? value;
}
